
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
    selector: 'lib-delivery-progress-bar',
    imports: [],
    templateUrl: './delivery-progress-bar.component.html',
    styleUrl: './delivery-progress-bar.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeliveryProgressBarComponent {
  statuses = input.required<string[]>();
  currentStatus = input.required<string>();

  progressBarWidth = computed(
    () => Math.min((this.getStatusIndex(this.currentStatus()) / (this.statuses().length - 1)) * 100, 100) + '%',
  );

  getStatusIndex(status: string): number {
    return this.statuses().indexOf(status);
  }
}
